export default "__VITE_ASSET__C_0e5vfH__"